import { Point } from "./demo";

export interface Property {
  type: string;
  value: string;
  id: number;
  key: string;
  confidence: number | null;
  refinedValue: string;
  boundingBoxes?: BoundingBox[];
}
export interface BoxDrawing {
  id: string;
  points: [Point, Point, Point, Point];
  theme: "default" | "warning" | "large" | "dimmed";
  groupIds: string[];
  page: number;
  // entity: string | null;
}

export interface BoundingBox {
  page: number;
  vertices: {
    x: number;
    y: number;
  }[];
}

export interface Theme {
  default: {
    fill: string;
    opacity: number;
    strokeOpacity: number;
    stroke: string;
    fillColor: string;
  };
  hovered: {
    fill: string;
    opacity: number;
    strokeOpacity: number;
    stroke: string;
    fillColor: string;
  };
  selected: {
    fill: string;
    opacity: number;
    strokeOpacity: number;
    stroke: string;
    fillColor: string;
  };
  corrected: {
    fill: string;
    opacity: number;
    strokeOpacity: number;
    stroke: string;
    fillColor: string;
  };
}
export const BoxTheme: Theme = {
  default: {
    fill: "relative",
    opacity: 0.0,
    strokeOpacity: 0.0,
    stroke: "",
    fillColor: "",
  },
  hovered: {
    fill: "relative stroke-white fill-[#518ffb]",
    opacity: 0.3,
    strokeOpacity: 0.4,
    stroke: "#FFFFFF",
    fillColor: "#518ffb",
  },
  selected: {
    fill: "relative stroke-white fill-[#518ffb]",
    opacity: 0.3,
    strokeOpacity: 0.4,
    stroke: "#FFFFFF",
    fillColor: "#518ffb",
  },
  corrected: {
    fill: "relative",
    opacity: 0.0,
    strokeOpacity: 0.0,
    stroke: "",
    fillColor: "",
  },
};
export const LargeBoxTheme: Theme = {
  default: {
    fill: "relative",
    opacity: 0.0,
    strokeOpacity: 0.0,
    stroke: "",
    fillColor: "",
  },
  hovered: {
    fill: "relative stroke-white fill-blue-400",
    opacity: 0.3,
    strokeOpacity: 0.4,
    stroke: "#FFFFFF",
    fillColor: "#518ffb",
  },
  selected: {
    fill: "relative stroke-white fill-blue-400",
    opacity: 0.3,
    strokeOpacity: 0.4,
    stroke: "#FFFFFF",
    fillColor: "#518ffb",
  },
  corrected: {
    fill: "relative",
    opacity: 0.0,
    strokeOpacity: 0.0,
    stroke: "",
    fillColor: "",
  },
};

export const DimmedBoxTheme: Theme = {
  default: {
    fill: "relative",
    opacity: 0.0,
    strokeOpacity: 0.0,
    stroke: "",
    fillColor: "",
  },
  hovered: {
    fill: "relative fill-gray-300",
    opacity: 0.0,
    strokeOpacity: 0.0,
    stroke: "",
    fillColor: "#D1D5DB",
  },
  selected: {
    fill: "relative fill-gray-300",
    opacity: 0.0,
    strokeOpacity: 0.0,
    stroke: "",
    fillColor: "#D1D5DB",
  },
  corrected: {
    fill: "relative",
    opacity: 0.0,
    strokeOpacity: 0.0,
    stroke: "",
    fillColor: "",
  },
};
export const WarningBoxTheme: Theme = {
  default: {
    fill: "relative",
    opacity: 0.0,
    strokeOpacity: 0.0,
    stroke: "",
    fillColor: "",
  },
  hovered: {
    fill: "relative stroke-white fill-blue-400",
    opacity: 0.3,
    strokeOpacity: 0.4,
    stroke: "#FFFFFF",
    fillColor: "#518ffb",
  },
  selected: {
    fill: "relative stroke-white fill-blue-400",
    opacity: 0.3,
    strokeOpacity: 0.4,
    stroke: "#FFFFFF",
    fillColor: "#518ffb",
  },
  corrected: {
    fill: "relative",
    opacity: 0.0,
    strokeOpacity: 0.0,
    stroke: "",
    fillColor: "",
  },
};
